<template>
  <div>
    <Main
      ref="tableMain"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openUploadFormDialog="() => (uploadFormDialogVisible = true)"
      @openEditFromDialog="openEditFromDialog"
      @reload="getData()"
    >
    </Main>
    <UploadFormDialog
      :title="$l('dialog_order_goods_package_doc_upload') || '上传产品包装文档'"
      :visible.sync="uploadFormDialogVisible"
      :orderCode="orderCode"
      @reload="getData()"
    />

    <EditFromDialog
      :title="$l('dialog_order_goods_package_doc_edit') || '编辑产品包装文档'"
      :visible.sync="editFromDialogOption.visible"
      :orderGoodsPackageDocCode="editFromDialogOption.code"
      :orderCode="orderCode"
      @reload="getData()"
    />
  </div>
</template>
<script>
import Main from './main'
import EditLoading from '@/mixins/edit-loading'
import UploadFormDialog from '../upload-form/dialog.vue'
import EditFromDialog from '../edit-form/dialog.vue'
export default {
  mixins: [EditLoading],
  components: { Main, UploadFormDialog, EditFromDialog },
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      uploadFormDialogVisible: false,
      editFromDialogOption: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.loading = true
      this.$api
        .orderGoodsPackageDocListApi({ orderCode: this.orderCode })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFromDialog(code) {
      this.editFromDialogOption = {
        visible: true,
        code,
      }
    },
  },
}
</script>
